// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__213l3","dragIcon":"Choice_dragIcon__3NZk4","left":"Choice_left__1BS6P","input":"Choice_input__2emb9"};